import { VerifyBox } from "../../Components/Login/Layout/Verify/VerifyBox";
import RedirectWrapper from "../Login/RedirectWrapper";
import { EnrollmentStepper } from "./EnrollmentStepper";
import { StepDefinePassword } from "./StepDefinePassword";
import { StepVerifySmsCode } from "./StepVerifySmsCode";
import { StepVerifyUser } from "./StepVerifyUser";
import { useVerifyUsernamePassword } from "./useVerifyUsernamePassword";

export const VerifyUsernamePassword = () => {
  const enrollUserNameAndPasswordProps = useVerifyUsernamePassword();
  const currentStep = enrollUserNameAndPasswordProps.enrollFlowState.step.kind;

  return (
    <RedirectWrapper>
      <VerifyBox {...enrollUserNameAndPasswordProps}>
        <EnrollmentStepper {...enrollUserNameAndPasswordProps} />
        {currentStep === "verifyUser" && <StepVerifyUser {...enrollUserNameAndPasswordProps} />}
        {currentStep === "verifySmsCode" && <StepVerifySmsCode {...enrollUserNameAndPasswordProps} />}
        {currentStep === "definePassword" && <StepDefinePassword {...enrollUserNameAndPasswordProps} />}
      </VerifyBox>
    </RedirectWrapper>
  );
};
